import React from "react";
import "./progress.scss";

const CircularProgressBar = ({ size = 1.5, variant = "dark" }) => {
  return (
    <progress
      style={{ width: `${size}em`, height: `${size}em` }}
      className={`pure-material-progress-circular text-${variant}`}
    />
  );
};

export default CircularProgressBar;
